import '../styles/Marquee.scss';

const ITEMS = [
  'San Francisco', 'Pacific Heights', 'Peninsula', 'Noe Valley',
  'Bay Area Real Estate', 'The Castro', 'South SF', 'Hayes Valley',
  'Buying & Selling', 'Marina District', 'Burlingame', 'The Mission',
];

function Marquee() {
  const doubled = [...ITEMS, ...ITEMS];
  return (
    <div className="marquee-strip" aria-hidden="true">
      <div className="marquee-inner">
        {doubled.map((item, i) => (
          <span key={i} className="marquee-item">
            {item}<span className="marquee-sep">·</span>
          </span>
        ))}
      </div>
    </div>
  );
}

export default Marquee;
